/** Approximate characters per line in story/testimonial card bodies at typical widths. */
const CHARS_PER_LINE = 48;

/** Visible excerpt lines before "Read more" (responsive CSS may use 4 on small screens). */
export const READ_MORE_CLAMP_LINES = 5;

export function needsReadMoreExcerpt(
  text: string,
  maxLines: number = READ_MORE_CLAMP_LINES,
  charsPerLine: number = CHARS_PER_LINE,
): boolean {
  const normalized = text.trim();
  if (!normalized) return false;
  return normalized.length > maxLines * charsPerLine - 16;
}
